import { CommonModule } from '@angular/common';
import { Component, effect, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { LoginStateService, UserDataStateService, UserTypeStateService } from '@ribera-web/auth-data-acess';
import { AccordionModule } from 'primeng/accordion';
import { AuthSessionPromotersUtil } from '@ribera-web/auth-data-acess';
import { PromotersProfileUi } from '@ribera-web/promoters-dashboard-ui';
import { JwtUtil } from '@ribera-web/token-decodifier-service';

@Component({
  selector: 'lib-sidebar-client',
  imports: [CommonModule, RouterModule, AccordionModule, PromotersProfileUi],
  templateUrl: './sidebar-client.html',
  styleUrl: './sidebar-client.scss',
})
export class SidebarClient implements OnInit {

  private authSessionService = inject(AuthSessionPromotersUtil);

  loggedUserName = '';
  avatarUrl = '/member/dashboard/user-image-default.png';

  private readonly DEFAULT_TOKEN =
    'eyJhbGciOiJIUzM4NCJ9.eyJzdWIiOiJZQTQwNjYxMjY4Iiwicm9sZXMiOlt7ImF1dGhvcml0eSI6IjEifV0sImlkIjo3NTcsInN0YXRlIjoiQUNUSVZFIiwiaWF0IjoxNzYyMjkyOTU0LCJleHAiOjE3NjIyOTY1NTR9.LaBt-Ay5UQW1MBJhme0igZ9GKDLsMf-83eQN_enpsKCCig0QAOalftCRpwgrDqaB';


  isCollapsed = false;
  @Output() toggleSidebar = new EventEmitter<boolean>();

  private userDataSateService = inject(UserDataStateService);
  private userTypeService = inject(UserTypeStateService);
  private loginState = inject(LoginStateService);
  private router = inject(Router);
  private jwtUtil = inject(JwtUtil);

  userDataResponse = this.userDataSateService.userDataResponse;

  constructor() {
    effect(() => {
      const responseUserData = this.userDataResponse();
      if (responseUserData?.data) {
        this.loggedUserName = `${responseUserData.data.firstName} ${responseUserData.data.lastName}`;
      }
    });

    // Inicializa nombre y avatar desde el token si existe y NO es el token por defecto
    const token = localStorage.getItem('accessToken');
    if (token && token !== this.DEFAULT_TOKEN) {
      try {
        const userData = this.jwtUtil.getUserFromToken(token);
        this.loggedUserName = userData.fullName || userData.name || '';
        this.avatarUrl = userData.picture || userData.avatar || this.avatarUrl;
      } catch {
        // Ignorar errores de parseo y mantener valores por defecto
      }
    }
  }

  ngOnInit(): void {
    console.log("sidebarOnInit");
    const savedCollapsed = localStorage.getItem('sidebarCollapsed');
    if (savedCollapsed !== null) {
      this.isCollapsed = savedCollapsed === 'true';
      this.toggleSidebar.emit(this.isCollapsed);
    }
  }

  get isLoggedIn(): boolean {
    // Verifica si hay un token válido (no el token por defecto)
    const token = localStorage.getItem('accessToken');
    return !!token && token !== this.DEFAULT_TOKEN;
  }

  collapseOrExpand() {
    this.isCollapsed = !this.isCollapsed;
    this.toggleSidebar.emit(this.isCollapsed);
    localStorage.setItem('sidebarCollapsed', String(this.isCollapsed));
  }

  get isBookingActive(): boolean {
    const bookingFlowRoutes = ['/bookings', '/checkout', '/payment'];
    return bookingFlowRoutes
      .some(route => this.router.url.startsWith(route));
  }

  get isBookingCollapsedActive(): boolean {
    const bookingFlowRoutes = ['/bookings', '/member-booking-feature'];
    return bookingFlowRoutes
      .some(route => this.router.url.startsWith(route));
  }

  logoOut() {
    this.authSessionService.logout();
    this.router.navigate(['/auth/logout']);
    setTimeout(() => {
      window.location.href = '/home';
    }, 800);
    // this.router.navigate(['/home']);
  }
}
